module.exports = __webpack_public_path__ + "img/thumbnail_Llama_f_albino.deccc70f.png";